import Report from './report'
import Card from './card'
import Edit from './edit'
import New from './new'

const card = {
  code: 'signups',
  card: Card,
  edit: Edit,
  new: New,
  report: Report
}

export default card
